import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.v6o_1 = partyId;
        this.w6o_1 = pinId;
        this.x6o_1 = icon;
        this.y6o_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.v6o_1.toString() + ', pinId=' + this.w6o_1.toString() + ', icon=' + this.x6o_1 + ', name=' + this.y6o_1 + ')';
      }
      hashCode() {
        var result = this.v6o_1.hashCode();
        result = imul(result, 31) + this.w6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.x6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.v6o_1.equals(other.v6o_1))
          return false;
        if (!this.w6o_1.equals(other.w6o_1))
          return false;
        if (!(this.x6o_1 === other.x6o_1))
          return false;
        if (!(this.y6o_1 === other.y6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
